const parser = new DOMParser()

export const parseXml = (document: string) => {
  const xml = parser.parseFromString(document, 'text/xml')
  // console.log(xml)
  return xml
}
